"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsStylesOverridesSymbol = void 0;
exports.ComponentsStylesOverridesSymbol = Symbol('ComponentsStylesOverrides');
//# sourceMappingURL=componentsStylesOverrides.js.map